import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Assessment from "../../images/services/ds/Market-Segmentation.webp";
import Strategy from "../../images/services/ds/Engagement-Parameters.webp";
import Testing from "../../images/services/ds/Value-Dispersion.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Our Forte">
                                <h2>Our Forte</h2>
                            </div>
                            {/*<p>TA digital strategy firm enabling your digital media efforts</p>*/}
                            <p>Tech-driven digital strategy firm helping you reach your goals</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>20%
                                        <span>Have Digital Strategy</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>70%
                                        <span>Daily data production</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Market Segmentation</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Engagement Parameters</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Value Dispersion</div>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Market Segmentation</h2>
                                <p>To devise a comprehensive digital strategy, TekRevol ensures complete market
                                    segmentation is done to cater to the audience's specific needs. We research, conduct
                                    surveys, and build plans to segment the market for appropriate targeting measures
                                    properly. Market segmentation provides us with the insights necessary for future
                                    steps.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Assessment}
                                    effect="blur" alt="Assessment" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Engagement Parameters</h2>
                                <p>We define engagement parameters in detail post-market segmentation to lay out a
                                    descriptive plan of action. We ensure, at any point, the relevancy is maintained,
                                    and the plan is client-focused to attain maximum helpful output. Citing the numbers,
                                    we explain the roadmap to your growth and digital success using emerging
                                    technologies.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Strategy}
                                    effect="blur" alt="Strategy" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Value Dispersion</h2>
                                <p>Providing value is as important as generating revenue. Our strategic guidelines focus
                                    on providing value to the end-users or customers. That builds authority when your
                                    business is new, and TekRevol does that for you. You will be dethroned if you miss
                                    either of them, preferably the former.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Testing}
                                    effect="blur" alt="Testing" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Technologysec;